import { SxProps, Theme } from '@mui/material';

export const styles: SxProps<Theme> = {
  borderRadius: '4px',
  display: 'inline-block',
};
